var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 148,
    viewBox: "0 0 240 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.287 70.4277C191.287 70.4277 202.306 68.7008 201.563 75.2269H191.287V70.4277Z",
    fill: "#F4A28C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.826 58.5556L163.497 74.2053H182.192L179.643 56.2172L166.826 58.5556Z",
    fill: "#D4DBE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.071 8.03778H135.908V56.8144H210.071V8.03778Z",
    fill: "#00274D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.298 40.2871H161.967V42.4097H185.298V40.2871Z",
    fill: "#016AD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.693 45.856H172.362V47.9786H195.693V45.856Z",
    fill: "#FFC248"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.071 52.6196H135.908V61.8511H210.071V52.6196Z",
    fill: "#EAEDF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.928 35.1566H156.349V37.2792H175.928V35.1566Z",
    fill: "#016AD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.579 35.1566H180V37.2792H199.579V35.1566Z",
    fill: "#016AD4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.472 29.2496H161.967V31.3722H179.472V29.2496Z",
    fill: "#FFC248"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M201.533 29.2496H184.027V31.3722H201.533V29.2496Z",
    fill: "#FFC248"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M157.865 40.2871H149.09V42.4097H157.865V40.2871Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.603 45.856H157.828V47.9786H166.603V45.856Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.248 35.1566H143.472V37.2792H152.248V35.1566Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M145.598 25.1626C145.598 25.1626 181.828 21.6369 173.833 61.8584L176.589 71.6655L165.281 65.7222L166.187 61.8656H160.198L145.598 25.1626Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.598 13.8299C146.168 13.8299 146.63 13.3821 146.63 12.8297C146.63 12.2774 146.168 11.8296 145.598 11.8296C145.027 11.8296 144.565 12.2774 144.565 12.8297C144.565 13.3821 145.027 13.8299 145.598 13.8299Z",
    fill: "#016AD4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.495 13.8299C149.066 13.8299 149.528 13.3821 149.528 12.8297C149.528 12.2774 149.066 11.8296 148.495 11.8296C147.925 11.8296 147.463 12.2774 147.463 12.8297C147.463 13.3821 147.925 13.8299 148.495 13.8299Z",
    fill: "#FFC248"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152.248 19.0177H143.472V21.1403H152.248V19.0177Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.865 24.3276H149.09V26.4502H157.865V24.3276Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M179.472 24.3276H161.967V26.4502H179.472V24.3276Z",
    fill: "#FFC248"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M201.533 24.3276H184.027V26.4502H201.533V24.3276Z",
    fill: "#FFC248"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.865 29.2496H149.09V31.3722H157.865V29.2496Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M173.833 19.0177H155.755V21.1403H173.833V19.0177Z",
    fill: "#016AD4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M190.447 19.0177H177.615V21.1403H190.447V19.0177Z",
    fill: "#016AD4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.833 59.5774C175.355 59.5774 176.589 58.3823 176.589 56.908C176.589 55.4337 175.355 54.2385 173.833 54.2385C172.31 54.2385 171.076 55.4337 171.076 56.908C171.076 58.3823 172.31 59.5774 173.833 59.5774Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9164 71.6869H31.6384V74.2052H68.9164V71.6869Z",
    fill: "#D4DBE0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4991 70.4277C46.4991 70.4277 35.4799 68.7008 36.223 75.2269H46.4991V70.4277Z",
    fill: "#F4A28C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9919 58.5556L63.6631 74.2053H82.3578L79.8092 56.2172L66.9919 58.5556Z",
    fill: "#D4DBE0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.131 8.03778H32.9685V56.8144H107.131V8.03778Z",
    fill: "#00274D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3579 40.2871H59.0266V42.4097H82.3579V40.2871Z",
    fill: "#016AD4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.131 52.6196H32.9685V61.8511H107.131V52.6196Z",
    fill: "#EAEDF0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9882 35.1566H53.4093V37.2792H72.9882V35.1566Z",
    fill: "#016AD4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5325 29.2496H59.0266V31.3722H76.5325V29.2496Z",
    fill: "#FFC248"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.925 40.2871H46.1498V42.4097H54.925V40.2871Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6632 45.856H54.8879V47.9786H63.6632V45.856Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3077 35.1566H40.5325V37.2792H49.3077V35.1566Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5888 13.8299C40.1593 13.8299 40.6217 13.3821 40.6217 12.8297C40.6217 12.2774 40.1593 11.8296 39.5888 11.8296C39.0184 11.8296 38.556 12.2774 38.556 12.8297C38.556 13.3821 39.0184 13.8299 39.5888 13.8299Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6576 13.8299C43.228 13.8299 43.6904 13.3821 43.6904 12.8297C43.6904 12.2774 43.228 11.8296 42.6576 11.8296C42.0872 11.8296 41.6248 12.2774 41.6248 12.8297C41.6248 13.3821 42.0872 13.8299 42.6576 13.8299Z",
    fill: "#016AD4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5555 13.8299C46.1259 13.8299 46.5883 13.3821 46.5883 12.8297C46.5883 12.2774 46.1259 11.8296 45.5555 11.8296C44.9851 11.8296 44.5227 12.2774 44.5227 12.8297C44.5227 13.3821 44.9851 13.8299 45.5555 13.8299Z",
    fill: "#FFC248"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3077 19.0177H40.5325V21.1403H49.3077V19.0177Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M54.925 24.3276H46.1498V26.4502H54.925V24.3276Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5325 24.3276H59.0266V26.4502H76.5325V24.3276Z",
    fill: "#FFC248"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M54.925 29.2496H46.1498V31.3722H54.925V29.2496Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M70.893 19.0177H52.8149V21.1403H70.893V19.0177Z",
    fill: "#016AD4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120 148C186.274 148 240 141.257 240 132.94C240 124.623 186.274 117.881 120 117.881C53.7258 117.881 0 124.623 0 132.94C0 141.257 53.7258 148 120 148Z",
    fill: "#00274D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M101.84 23.5582C101.84 23.5582 75.9752 25.2779 73.9913 39.1863C72.8916 46.914 75.0761 53.9006 77.2383 58.6135C77.5679 59.3295 77.7203 60.1101 77.6835 60.8932C77.6467 61.6762 77.4217 62.4402 77.0263 63.1242C76.6309 63.8082 76.0761 64.3934 75.406 64.8332C74.7359 65.2731 73.9691 65.5554 73.1665 65.6577L46.499 69.2553V75.2633L83.6061 74.1984C87.3706 74.0908 90.9633 72.6488 93.7026 70.1461C96.4419 67.6433 98.1372 64.2539 98.4668 60.621L101.84 23.5582Z",
    fill: "#016AD4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.908 23.5582C135.908 23.5582 161.773 25.2779 163.757 39.1863C164.857 46.914 162.673 53.9006 160.51 58.6135C160.181 59.3295 160.028 60.1101 160.065 60.8932C160.102 61.6762 160.327 62.4402 160.722 63.1242C161.118 63.8082 161.673 64.3934 162.343 64.8332C163.013 65.2731 163.78 65.5554 164.582 65.6577L191.25 69.2553V75.2633L154.135 74.1625C150.371 74.0533 146.779 72.6108 144.04 70.1083C141.301 67.6059 139.606 64.2174 139.274 60.585L135.908 23.5582Z",
    fill: "#016AD4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M101.84 23.5582C101.84 23.5582 75.9752 25.2779 73.9913 39.1863C72.8916 46.914 75.0761 53.9006 77.2383 58.6135C77.5679 59.3295 77.7203 60.1101 77.6835 60.8932C77.6467 61.6762 77.4217 62.4402 77.0263 63.1242C76.6309 63.8082 76.0761 64.3934 75.406 64.8332C74.7359 65.2731 73.9691 65.5554 73.1665 65.6577L46.499 69.2553V75.2633L83.6061 74.1984C87.3706 74.0908 90.9633 72.6488 93.7026 70.1461C96.4419 67.6433 98.1372 64.2539 98.4668 60.621L101.84 23.5582Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M135.908 23.5582C135.908 23.5582 161.773 25.2779 163.757 39.1863C164.857 46.914 162.673 53.9006 160.51 58.6135C160.181 59.3295 160.028 60.1101 160.065 60.8932C160.102 61.6762 160.327 62.4402 160.722 63.1242C161.118 63.8082 161.673 64.3934 162.343 64.8332C163.013 65.2731 163.78 65.5554 164.582 65.6577L191.25 69.2553V75.2633L154.135 74.1625C150.371 74.0533 146.779 72.6108 144.04 70.1083C141.301 67.6059 139.606 64.2174 139.274 60.585L135.908 23.5582Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M216.78 79.76H21.7338V132.947H216.78V79.76Z",
    fill: "#D4DBE0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M216.78 74.2052H21.7338V87.207H216.78V74.2052Z",
    fill: "#EAEDF0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M116.485 23.5578L119.643 10.225C119.643 10.225 119.747 3.97947 123.886 5.43291C128.025 6.88635 129.266 14.1248 127.037 16.5712C124.807 19.0176 123.321 15.679 123.321 15.679V23.0541L116.485 23.5578Z",
    fill: "#F4A28C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.076 74.6516C171.076 74.6516 153.934 78.1844 161.097 84.8832C168.26 91.582 164.307 101.001 159.344 103.72C154.38 106.44 133.821 109.721 140.389 132.667H117.214L115.505 120.435L100.644 105.239L107.138 90.5819L125.409 66.5281L137.788 76.4648L144.565 74.2055L171.076 74.6516Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M112.362 22.9465C112.362 22.9465 86.5783 20.7232 83.2124 37.5816C79.8464 54.4401 103.839 86.2576 103.839 86.2576L137.276 84.9984C137.276 84.9984 189.221 14.341 112.362 22.9465Z",
    fill: "#016AD4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M115.497 120.413C115.497 120.413 116.983 122.313 116.01 124.112C115.037 125.91 116.441 127.436 117.912 126.184C119.383 124.932 119.993 119.708 119.993 119.708L116.671 117.83L115.497 120.413Z",
    fill: "#016AD4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M103.839 86.2574C103.839 86.2574 101.61 97.5899 106.625 98.1295C111.641 98.6692 147.121 100.202 153.065 95.3882C159.009 90.5745 157.523 83.9189 137.276 84.9982L103.839 86.2574Z",
    fill: "#00274D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M103.549 88.2145C103.549 88.2145 88.0496 99.9428 96.0372 108.577C104.025 117.211 115.542 122.248 115.542 122.248L117.214 118.111C117.214 118.111 93.0651 99.9428 115.913 96.3452L103.549 88.2145Z",
    fill: "#00274D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M123.388 50.0436H114.271C104.882 50.0436 97.2705 57.4143 97.2705 66.5064C97.2705 75.5985 104.882 82.9691 114.271 82.9691H123.388C132.777 82.9691 140.389 75.5985 140.389 66.5064C140.389 57.4143 132.777 50.0436 123.388 50.0436Z",
    fill: "#FFC248"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M122.883 66.5062H114.398V99.4821H122.883V66.5062Z",
    fill: "#FFC248"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M122.883 66.5062H114.398V99.4821H122.883V66.5062Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M135.908 95.3882H101.84V105.239H135.908V95.3882Z",
    fill: "#FFC248"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M117.459 14.5927L117.511 11.434C117.533 10.707 117.404 9.98314 117.131 9.30566C116.857 8.62818 116.446 8.01099 115.921 7.49098C115.705 7.3279 115.524 7.12506 115.389 6.89413C115.254 6.66319 115.167 6.40871 115.134 6.14528C115.101 5.88186 115.122 5.61469 115.196 5.35913C115.27 5.10356 115.395 4.86462 115.564 4.65605C117.273 2.28881 118.715 3.8214 120.438 1.72758C122.162 -0.36624 123.463 -0.77637 125.476 1.72758C127.49 4.23153 129.073 1.31025 130.224 4.37543C131.376 7.44061 130.365 8.97321 125.907 9.25382C122.118 9.49126 123.292 13.6501 119.777 15.8375C119.55 15.9865 119.284 16.0717 119.01 16.0835C118.736 16.0953 118.463 16.0334 118.223 15.9044C117.983 15.7755 117.785 15.5847 117.65 15.3531C117.515 15.1216 117.449 14.8584 117.459 14.5927Z",
    fill: "#00274D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M121.352 105.231H115.943V127.99H121.352V105.231Z",
    fill: "#FFC248"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M121.352 105.231H115.943V127.99H121.352V105.231Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M115.943 127.99L105.481 137.344H132.632L121.345 127.99H115.943Z",
    fill: "#FFC248"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M206.994 91.8335H186.932V125.471H206.994V91.8335Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M182.229 87.2071H177.526V132.947H182.229V87.2071Z",
    fill: "#EAEDF0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M216.78 87.2071H212.077V132.947H216.78V87.2071Z",
    fill: "#EAEDF0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M216.788 125.472H181.768V132.94H216.788V125.472Z",
    fill: "#EAEDF0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6384 87.2071H21.7338V132.947H31.6384V87.2071Z",
    fill: "#EAEDF0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.8737 120.01H31.6384V125.472H59.8737V120.01Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.1697 125.256H31.6384V132.94H74.1697V125.256Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5072 19.0177H74.675V21.1403H87.5072V19.0177Z",
    fill: "#016AD4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.8099 59.5774C74.3323 59.5774 75.5665 58.3823 75.5665 56.908C75.5665 55.4337 74.3323 54.2385 72.8099 54.2385C71.2874 54.2385 70.0532 55.4337 70.0532 56.908C70.0532 58.3823 71.2874 59.5774 72.8099 59.5774Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M142.529 13.8299C143.099 13.8299 143.562 13.3821 143.562 12.8297C143.562 12.2774 143.099 11.8296 142.529 11.8296C141.958 11.8296 141.496 12.2774 141.496 12.8297C141.496 13.3821 141.958 13.8299 142.529 13.8299Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M44.1659 111.865C44.1659 111.865 37.3226 110.052 35.8291 103.886C35.8291 103.886 46.4396 101.814 46.7368 112.412L44.1659 111.865Z",
    fill: "#009D93"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M44.9685 111.239C44.9685 111.239 40.1833 103.914 44.3963 97.0717C44.3963 97.0717 52.4582 102.029 48.8545 111.254L44.9685 111.239Z",
    fill: "#009D93"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2019 111.239C46.2019 111.239 48.7282 103.512 56.3666 102.044C56.3666 102.044 57.7932 107.08 51.418 111.261L46.2019 111.239Z",
    fill: "#009D93"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2384 111.038L42.6204 120.233L51.3585 120.269L52.6514 111.088L41.2384 111.038Z",
    fill: "#00274D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M200.359 102.022C201.779 102.022 202.93 100.908 202.93 99.5327C202.93 98.1578 201.779 97.0432 200.359 97.0432C198.939 97.0432 197.788 98.1578 197.788 99.5327C197.788 100.908 198.939 102.022 200.359 102.022Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M204.349 105.231H190.358V122.234H204.349V105.231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculating);
export default __webpack_public_path__ + "static/media/calculating.04dc0032bce504e320d50808d38198ac.svg";
export { ForwardRef as ReactComponent };